import { Alert, Card, Col, Row } from 'react-bootstrap';

function formatSessionTime(value) {
  if (!value) {
    return '-';
  }
  return String(value).slice(0, 5);
}

function EventSessionCards({
  sessions,
  emptyMessage = 'No hay sesiones registradas para este evento.',
  containerClassName = 'd-flex flex-column gap-3',
  bodyClassName = '',
}) {
  const rows = Array.isArray(sessions) ? sessions : [];

  if (!rows.length) {
    return <Alert variant="info" className="mb-0">{emptyMessage}</Alert>;
  }

  return (
    <div className={containerClassName}>
      {rows.map((session) => (
        <Card key={session.event_session_id || `${session.session_date}-${session.start_time}`}>
          <Card.Body className={bodyClassName}>
            <Row className="g-2">
              <Col md={6}><strong>Fecha:</strong> {session.session_date || '-'}</Col>
              <Col md={3}><strong>Hora inicio:</strong> {formatSessionTime(session.start_time)}</Col>
              <Col md={3}><strong>Hora fin:</strong> {formatSessionTime(session.end_time)}</Col>
              <Col md={6}><strong>Lugar:</strong> {session.location_name || 'Sin lugar definido'}</Col>
              <Col md={6}><strong>Direccion:</strong> {session.location_address || 'Sin direccion definida'}</Col>
              <Col md={12}>
                <strong>Enlace:</strong>{' '}
                {session.meeting_url ? (
                  <a href={session.meeting_url} target="_blank" rel="noreferrer">{session.meeting_url}</a>
                ) : (
                  'Sin enlace'
                )}
              </Col>
            </Row>
          </Card.Body>
        </Card>
      ))}
    </div>
  );
}

export default EventSessionCards;
